export const DOWNLOAD_IMPORTER = 'DOWNLOAD_IMPORTER'

export const FILE_NAME = 'group_importer.zip'
export const MANUAL_URL = 'https://source.bisnode.cz/data/gnosus/Bisnode_Importer_manual.pdf'

export const LOCALE_PREFIX = 'components.Dialog.components.UserProfile.components.Content.components.Importer'
